module.exports = function() {
  return new Worker(__webpack_public_path__ + "53ec60fdfe5fb700f0fc.worker.js");
};